import Logo from "../../assets/logo.png";
import Login from "../../pages/home/login";
import arrowup from "../../assets/CourseUp.svg";
import { Modal } from "flowbite-react";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "flowbite-react";

function Header() {
  const [openModal, setOpenModal] = useState(false);
  const [toggle, setToggle] = useState(false);

  return (
    <>
      <header className="mx-auto p-2 md:px-8 lg:px-15 md:p-5">
        <Navbar fluid={true} rounded={false}>
          <Navbar.Brand className="w-full flex flex-wrap items-center justify-between">
            <Link to="/" className="flex items-center">
              <img
                src={Logo}
                className="w-[140px] md:max-w-48 md:w-full"
                alt="Flowbite Logo"
              />
            </Link>
            <div className="hidden md:block">
              <Link className="p-3" to="/aboutus">
                <a
                  href="/aboutus"
                  className="font-semibold text-lg font-primary hover"
                >
                  About us
                </a>
              </Link>
              <Link className="p-3" to="/ourproducts">
                <a
                  href="/ourproducts"
                  className="font-semibold text-lg font-primary hover"
                >
                  Our Products
                </a>
              </Link>
              <Link className="p-3" to="/contactus">
                <a
                  href="/contactus"
                  className="font-semibold text-lg font-primary hover"
                >
                  Contact Us
                </a>
              </Link>
            </div>
            <div className="flex md:order-2">
              <div className="flex-col gap-2 hidden md:flex-row md:gap-5 md:flex">
                <div class="hover01 column">
                  <div>
                    <figure>
                      <div>
                        {/* <button
                          onClick={() => setOpenModal(true)}
                          className="w-full hover:bg-[#100a55e5] rounded text-sm font-bold bg-primary text-white p-2 md:px-7 py-3.5"
                        >
                          Log In
                        </button> */}
                        <a href="http://fbtb2b.com/agent/login">
                          <button className="w-full hover:bg-[#100a55e5] rounded text-sm font-bold bg-primary text-white p-2 md:px-7 py-3.5">
                            Log In
                          </button>
                        </a>
                      </div>
                    </figure>
                  </div>
                </div>
                <div class="hover01 column">
                  <div>
                    <figure>
                      <div>
                        <a href="http://fbtb2b.com/agent/agent-registration-page">
                          <button className="w-full justify-center rounded hover:bg-[rgb(255,133,0)] flex gap-1 text-sm items-center font-bold bg-secondary text-white p-2 md:px-7 py-3">
                            <span className="text-white">Register Now</span>
                            <img src={arrowup} alt="FBT" />
                          </button>
                        </a>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="md:hidden flex align-middle justify-center p-1 text-gray-800 dark:text-white">
                <button
                  onClick={(e) => setToggle(!toggle)}
                  type="button"
                  className="inline-flex items-center bg-[rgb(239,127,26)] p-2 w-10 h-10 justify-center text-sm text-white rounded-lg md:hidden hover:bg-[rgb(255,133,0)]  focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                >
                  <span className="sr-only">Open main menu</span>
                  <svg
                    className="w-5 h-5"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 17 14"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M1 1h15M1 7h15M1 13h15"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </Navbar.Brand>
          {toggle ? (
            <div className="p-2 m-5 bg-white dark:bg-gray-600 rounded-lg dark:text-white w-full">
              <div>
                <ul className="flex flex-col gap-3 divide-y md:divide-y-0 w-full items-center font-medium">
                  <li className="w-full text-center py-2 md:w-fit">
                    <a
                      href="/aboutus"
                      className="font-semibold text-lg font-primary hover"
                    >
                      About us
                    </a>
                  </li>
                  <li className="w-full text-center py-2 md:w-fit">
                    <a
                      href="/ourproducts"
                      className="font-semibold text-lg font-primary hover"
                    >
                      Our Products
                    </a>
                  </li>
                  <li className="w-full text-center py-2 md:w-fit">
                    <a
                      href="/contactus"
                      className="font-semibold text-lg font-primary hover"
                    >
                      Contact Us
                    </a>
                  </li>
                  <li className="block w-full md:hidden md:w-fit">
                    <div className="flex flex-col gap-2 md:flex-row md:gap-5">
                      <div>
                        <button
                          onClick={() => setOpenModal(true)}
                          className="w-full hover:bg-[#100a55e5] rounded text-sm font-bold bg-primary text-white p-2 md:px-7 py-3.5"
                        >
                          Log In
                        </button>
                      </div>
                      <div>
                        <a href="/register">
                          <button className="w-full justify-center rounded hover:bg-[rgb(255,133,0)] flex gap-1 text-sm items-center font-bold bg-secondary text-white p-2 md:px-7 py-3">
                            <span className="text-white">Register Now</span>
                            <img src={arrowup} alt="FBT" />
                          </button>
                        </a>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          ) : null}
        </Navbar>

        {/* Login Modal */}
        <Modal
          show={openModal}
          size="md"
          defaultValue="center"
          onClose={() => setOpenModal(false)}
        >
          <Modal.Body className="relative">
            <button
              onClick={() => setOpenModal(false)}
              className="absolute top-[0] font-secondary z-10 right-[1%]"
            >
              <i className="ri-close-line text-4xl "></i>
            </button>
            <Login />
          </Modal.Body>
        </Modal>
      </header>
    </>
  );
}

export default Header;
